import { accessControl, roles } from '@minty/shared/permissions';
import {
  adminClient,
  genericOAuthClient,
  oneTimeTokenClient,
  twoFactorClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

/** Same origin as the app, so the client finds `/api/auth` by itself. */
export const authClient = createAuthClient({
  plugins: [
    adminClient({ ac: accessControl, roles }),
    genericOAuthClient(),
    oneTimeTokenClient(),
    twoFactorClient(),
  ],
});

let signedIn: Promise<boolean> | undefined;

/** Asked once per document load — every auth transition here ends in one. */
export function isSignedIn() {
  signedIn ??= authClient
    .getSession()
    .then(({ data }) => Boolean(data?.session))
    .catch(() => false);

  return signedIn;
}
